type DiagonalCurrencyPairProps = {
  logo0: string
  logo1: string
  size?: number
  className?: string
}

export default function DiagonalCurrencyPair({ logo0, logo1, size = 24, className = '' }: DiagonalCurrencyPairProps) {
  return (
    <div className={`relative overflow-hidden rounded-full ${className}`} style={{ width: size, height: size }}>
      {/* Top-left triangle (logo0) */}
      <div
        className="absolute inset-0"
        style={{
          clipPath: 'polygon(0 0, calc(100% - 2px) 0, 0 calc(100% - 2px))',
        }}
      >
        <img
          src={logo0}
          alt="Currency 0"
          className="w-full h-full object-cover"
          style={{ width: size, height: size }}
        />
      </div>

      {/* Bottom-right triangle (logo1) */}
      <div
        className="absolute inset-0"
        style={{
          clipPath: 'polygon(calc(100% - 1px) calc(0% + 2px), 100% 0, 100% 100%, calc(0% + 2px) 100%)',
        }}
      >
        <img
          src={logo1}
          alt="Currency 1"
          className="w-full h-full object-cover"
          style={{ width: size, height: size }}
        />
      </div>
    </div>
  )
}
